import { render, staticRenderFns } from "./SanIDList.vue?vue&type=template&id=33e575dc&"
import script from "./SanIDList.vue?vue&type=script&lang=ts&"
export * from "./SanIDList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports